module.exports = __webpack_public_path__ + "static/img/59-1.c37873d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/59-1.jpg
// module id = V9G/
// module chunks = 0